import "./skipnav.css";
import React from "react";

const SkipNav = () => {
  return (
    <>
      <nav className="coop-c-skip-nav">
        <ul className="coop-c-skip-nav__list">
          <li>
            <a
              href="#main"
              title="Skip to main content"
              className="coop-c-skip-nav__link"
            >
              Skip to content
            </a>
          </li>
          <li>
            <a
              href="#navigation"
              title="Skip to main navigation"
              className="coop-c-skip-nav__link"
            >
              Skip to main navigation
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default SkipNav;
